import { gql } from '@apollo/client';

export const MillPolygon = gql`
  query NE_millPolygon($inputId: Int!) {
    coords: niaga_working_polygon(input: $inputId)
}
`

export const disablePersonFromCompany = gql`
mutation NE_RemovePersonFromCompany($input: deactivate_employee_input!) {
  deactivate_employee(input: $input){
  organisation {
      id
    }
  }
}`

export const enablePersonFromCompany = gql`
mutation NE_RemovePersonFromCompany($input: reactivate_employee_input!) {
  reactivate_employee(input: $input){
  organisation {
      id
    }
  }
}`

export const updateGroupPrice = gql`
mutation NE_UpdateGroupPrice($price: Int!, $group_id: Int!) {
  niaga_upsert_bid_delta_group(input: {delta_price: $price, group_id: $group_id}) {
    organisation_id
  }
}`

export const updateGroupPricePrivacy = gql`
mutation NE_updateGroupPricePrivacy($input: [niaga_group_set_privacy_input!], $orgId: Int!, $namPrivacy: Boolean!) {
  niaga_group_set_privacy(input: $input)
  niaga_toggle_nam(input: {organisation_id: $orgId, is_enabled: $namPrivacy})
}`

export const GetTraceabilityData = gql`
query NeFruitOrigin($filter: JSON, $pipeline: [JSON]!) {
  mills: bi_fruit_originAggregate(pipeline: $pipeline)
  contracts: bi_fruit_originMany(rawFilter: $filter) {
    contract_id
    market_day
    status
    quantity
    price
    seller_statements
    _created_at
    _updated_at
    mill_id
    mill_name
    invoiced
  }
}`

export const GetNAFV3Contract = gql`
query NE_niagaNafV3Details($statementId: Int!) {
  contract: naf_contract_detail(statement_id: $statementId) {
    transporter {
      person {
        first_name
        last_name
        location {
          village
          district
          subdistrict
          province
        }
      }
    }
    statement {
      id
      total_amount
      total_amount_due
      line_items {
        sku
        total
        quantity
        price_per_unit
      }
      photos {
        uri
        type
        position {
          coordinates
        }
      }
    }
    harvests {
      land_plot {
        id
        name
        polygon {
          coordinates
        }
      }
      id
      photos {
        uri
        type
        position {
          coordinates
        }
      }
    }
    contract_id
    market_day
    type
    status
    buyer {
      organisation {
        name
        id
      }
    }
  }
}
`

export const getContractAgent = gql`
query NE_GetAgentContract($statementId: Int!) {
  contract: nam_contract_detail(filter: { statement_id: $statementId }) {
    contract_id
    status
    market_day
    harvests {
      loaded_quantity
      photos {
        uri
        type
        position {
          coordinates
        }
      }
      land_plot {
        id
        name
        polygon {
          coordinates
        }
        pickup_position {
          coordinates
        }
      }
    }
    statement {
      id
      total_amount
      photos {
        type
        uri
      }
      line_items {
        sku
        total
        quantity
        price_per_unit
        title
      }
    }
    agent_person {
     first_name
     last_name
     location {
       village
       district
     }
     avatar_uri
    }
    buyer {
      id
      name
    }
    agent {
      id
      name
    }
  }
}
`

export const UpsertBid = gql`
mutation NE_UpsertNiagaBid($input: niaga_upsert_bid_input!) {
  bid: niaga_upsert_bid(input: $input) {
    organisation_id
    bids {
      market_day
      price_per_kg
      updated_at
      updated_by
      grading {
        cardinality
        grading
        grading_name
      }
    }
  }
}`

export const GetBidsForOrgId = gql`
query NE_NiagaBuyerBidForOrgId($id: Int) {
  bids: niaga_bid(filter: {organisation_id: $id}) {
    organisation_id
    organisation_name
    organisation_position {
      coordinates
    }
    bids {
      id
      market_day
      price_per_kg
      updated_at
      updated_by
      grading {
        cardinality
        grading
        grading_name
      }
    }
     groups {
      group_delta_boost
      group_name        
      group_id
    }
  }
}`


export const createQBP = gql`
mutation NE_createQBP($input: niaga_add_grading_group_metadata_input!) {
  niaga_add_grading_group_metadata(
    input: $input
  )
}`

export const deleteQBP = gql`
mutation NE_deleteQBP($id: Int!) {
  niaga_clear_quality_based(organisation_id: $id)
}
`

export const upsertQBP = gql`
mutation NE_upsertQBP($input: niaga_upsert_quality_based_input!) {
  niaga_upsert_quality_based(
    input: $input
  ) {
    organisation_id
  }
}`